// @material-ui
import { makeStyles } from '@material-ui/styles'

export const currencyRatesStyle = theme => ({
  root: {},

  column: {
    display: 'flex',
    flexDirection: 'column',
  },
})

export const useCurrencyRatesStyle = makeStyles(currencyRatesStyle)
